<div class="breadcrumb-area">
	<h1>Usuarios y roles</h1>
</div>
<div class="card">
	<div class="card-header">
		<h3>1. Selecciona el usuario a editar</h3>
	</div>
	<div class="card-body">
		<div class="input-group form-group">
			<label for="email" class="input-group-text">Usuario</label>
			<button class="btn btn-primary" (click)="showAndHide(true)">
				<i class="fa fa-user-plus"></i>
			</button>
			<input type="text" id="email" placeholder="Filtra por el email del usuario" name="email" autocomplete="off"
				(input)="filter()" [(ngModel)]="email" class="form-control">
		</div>
		<div class="row">
			<div [ngClass]="creating?'col-sm-4':'col-sm'" *ngIf="creating" style="padding: 1em;">
				<h3>Crea un usuario</h3>
				<div class="form-group">
					<label for="userName" class="form-label">Nombre de Usuario</label>
					<input type="text" [(ngModel)]="newUser.userName" id="userName" name="userName"
						class="form-control">
				</div>
				<div class="form-group mb-3">
					<label for="userEmail" class="form-label">Correo de Usuario</label>
					<input type="text" (input)="errorMessageEmail = ''" [(ngModel)]="newUser.email" id="userEmail"
						name="userEmail" class="form-control">
					<span class="form-text" *ngIf="errorMessageEmail!=''">{{errorMessageEmail}}</span>
				</div>
				<div class="button-container">
					<button class="btn btn-danger" (click)="showAndHide(false)"><i
							class="fa fa-xmark"></i>CANCELAR</button>
					<button class="btn btn-primary" (click)="checkAndSaveUser()"
						[disabled]="loading || !newUser.userName || !newUser.email">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
			<div [ngClass]="creating?'col-sm-8':'col-sm'">
				<div class="table-responsive" style="max-height: 500px; overflow: auto;"
					*ngIf="this.filterUsers.length > 0">
					<table class="table table-hover">
						<caption>Selecciona un usuario haciendo click sobre los datos del mismo</caption>
						<thead>
							<tr>
								<th>Email</th>
								<th>Nombre</th>
								<th>Apellido</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let user of filterUsers">
								<tr (click)="selectedUser(user)" [class.checked]="userSelected?.email==user.email"
									[class.hide-all]="wait?.id==user.id">
									<td>{{user.email}}</td>
									<td>{{user.firstName}}</td>
									<td>{{user.lastName}}</td>
									<td>
										<div class="container-superposition" title="Borrar">
											<div class="element-superposition" *ngIf="wait?.id == user.id">
												<span class="text-info">¿Está seguro que desea eliminar este usuario?</span>
												<span class="a-container">
													<span class="a-hover" (click)="resetDeletingDiv()"><i
															class="fa fa-ban"></i>NO</span>
													<span class="a-hover text-danger"><i class="fa fa-trash"
															(click)="deleteUser(user)"></i>SÍ</span>
												</span>
											</div>
											<span class="clickeable text-danger">
												<i *ngIf="!deleting[user.id]" class="fa fa-trash"
													(click)="showDeleteQuestion(user)"></i>
												<span *ngIf="deleting[user.id]" class="spinner-border spinner-border-sm"
													aria-hidden="true"></span>
											</span>
										</div>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div *ngIf="this.filterUsers.length == 0">
			<span>No existen usuarios con el email <b>{{email}}</b> ingresado</span>
		</div>
	</div>
</div>
<div class="card mt-2" [class.blur]="!userSelected">
	<div class="card-header">
		<h3>2. Selecciona el puesto del usuario con email {{userSelected?.email}}</h3>
	</div>
	<div class="card-body">
		<ng-container *ngIf="actualPosition">
			<span>La posición actual del usuario es {{actualPosition.name}}</span>
			<hr>
		</ng-container>
		<span>Estás viendo los puestos según el area y departamento</span>
		<div class="row">
			<div class="col-sm">
				<div class="input-group input-group-sm">
					<label for="area" class="input-group-text">Area</label>
					<select name="area" id="area" [(ngModel)]="area" (ngModelChange)="changeArea()" class="form-select"
						[disabled]="areas.length<=1">
						<option *ngFor="let area of areas" value="{{area.id}}">{{area.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="input-group input-group-sm">
					<label for="department" class="input-group-text">Departamento</label>
					<select name="department" [(ngModel)]="department" (ngModelChange)="changeDepartment()"
						id="department" class="form-select">
						<ng-container *ngFor="let department of departments">
							<option *ngIf="department.area == area" value="{{department.id}}">{{department.name}}
							</option>
						</ng-container>
					</select>
				</div>
			</div>
		</div>
		<div class="table-responsive">
			<table class="table table-striped">
				<thead>
					<tr>
						<th>Nombre</th>
						<th>Superior</th>
					</tr>
				</thead>
				<tbody>
					<tr [class.checked]="position.id == actualPosition?.id || position.id==positionUser"
						*ngFor="let position of positions" (click)="actualPosition = null; positionUser = position.id">
						<td>{{position.name}}</td>
						<td>{{position.superiorName?position.superiorName:'--'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>

<div class="card mt-2" [class.blur]="!positionUser">
	<div class="card-header">
		<h3>3. Selecciona bodegas</h3>
	</div>
	<div class="card-body">
		<span>Selecciona las bodegas que puede ver el usuario</span>
		<div class="table-responsive">
			<table class="table table-striped">
				<thead>
					<tr>
						<th>Código</th>
						<th>Nombre</th>
						<th>Superior</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let w of warehouses" (click)="w.selected = !w.selected" [class.checked]="w.selected">
						<td>{{w.warehouse.code}}</td>
						<td>{{w.warehouse.name}}</td>
						<td>{{w.warehouse.address}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>

<div class="card mt-2" [class.blur]="!positionUser">
	<div class="card-header">
		<h3>4. Selecciona cajas</h3>
	</div>
	<div class="card-body">
		<span>Selecciona las cajas que puede ver el usuario</span>
		<div class="table-responsive">
			<table class="table table-striped">
				<thead>
					<tr>
						<th class="td-center">Nombre</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let c of cashiers" (click)="c.selected = !c.selected" [class.checked]="c.selected">
						<td class="td-center">{{c.name}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<button class="btn btn-success" (click)="saveUser()" [disabled]="!userSelected || !positionUser"> <i
			class="fa fa-floppy-disk"></i>GUARDAR</button>
</div>
<div class="hide-background" *ngIf="wait">
	<div class="for-click" (click)="resetDeletingDiv()"></div>
</div>